import React from 'react';

export default class SQRList extends React.Component {


render() {
let { data, nameLast} = this.props;

return (
<React.Fragment>
  {data.map((data, idx) => {
  let name = data.name ? nameLast + '/'+ data.name : null;
  return (<React.Fragment key={idx}>
    <ListElement key={idx} data={data} nameLast={name} idx={idx} getSQR={this.props.getSQR}/>
  </React.Fragment>)
  })}
</React.Fragment>
)

}

}


export class ListElement extends React.Component {

constructor() {
  super();
  this.state={
    cardShow: false,
  }

}

render() {
let { idx, data, nameLast } = this.props;
let { cardShow } = this.state;
let cardClass = cardShow ? "card-body" : "hideCard";

return (
<React.Fragment key={idx}>
  {data.isFile ? (
    <div className="d-flex flex-row mt-3 ml-0" id={idx}><button className="btn btn-light" onClick={(e) => (this.props.getSQR(e, nameLast))}><i className="far fa-file m-1"></i> {data.title}</button></div>
  ) : (
  <div className="card mt-3 ml-0" key={idx} id={idx} >
  <div className="card-header pointer" onClick={() => (this.setState(prevState => ({ cardShow: !prevState.cardShow })))}>
    {cardShow ? (<i className="far fa-folder-open"></i>) : (<i className="far fa-folder"></i>)} <b>{data.Name}</b>
  </div>
  <div className={cardClass}>
    {data.inner.map((data, idx) => {
    let name = data.name ? nameLast + '/'+ data.name : null;
    return (<React.Fragment key={idx}>
      <ListElement key={idx} data={data}  nameLast={name} idx={idx} getSQR={this.props.getSQR} />
    </React.Fragment>)
    })}
  </div>
  </div>
  )}
</React.Fragment>
)


}
}